import { render, staticRenderFns } from "./AmountSelect.vue?vue&type=template&id=002037c6&scoped=true&"
import script from "./AmountSelect.vue?vue&type=script&lang=js&"
export * from "./AmountSelect.vue?vue&type=script&lang=js&"
import style0 from "./AmountSelect.vue?vue&type=style&index=0&id=002037c6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002037c6",
  null
  
)

export default component.exports